import { render } from "./matching-game-page.vue?vue&type=template&id=18a72a1c&scoped=true"
import script from "./matching-game-page.vue?vue&type=script&lang=js"
export * from "./matching-game-page.vue?vue&type=script&lang=js"

import "./matching-game-page.vue?vue&type=style&index=0&id=18a72a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a72a1c"]])

export default __exports__